/**
 * Listado de formato de fechas.
 *
 * @readonly
 * @enum {string}
 */
const FORMAT_DATE = {
  FRONT: 'dd/MM/yyyy',
  FILTER: 'MM/dd/yyyy',
  HOURS_MINUTES: 'HH:mm',
  BACK_DATE_HOURS_MINUTES: 'yyyy/MM/dd HH:mm:ss',
  EDIT_DATE: 'yyyy-MM-dd',
};

export default FORMAT_DATE;
